<template>
  <div class="product-list">
    <el-card v-loading="enumLoading">
      <template #header>
        <div class="card-header">
          <span>贷款产品列表</span>
          <el-button type="primary" @click="handleEdit">添加产品</el-button>
        </div>
      </template>

      <!-- 搜索区域 -->
      <div class="search-area">
        <el-form :inline="true" :model="filters" class="search-form">
          <el-form-item label="银行">
            <el-select v-model="filters.bank_id" placeholder="请选择银行" clearable style="width: 200px;">
              <el-option 
                v-for="type in banks"
                :key="type.code"
                :value="type.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ type.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ type.code }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="贷款类型">
            <el-select v-model="filters.loan_type" placeholder="请选择贷款类型" clearable style="width: 200px;">
              <el-option
                v-for="type in loanTypes"
                :key="type.code"
                :value="type.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ type.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ type.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="贷款用途">
            <el-select v-model="filters.loan_purpose" placeholder="请选择贷款用途" clearable style="width: 200px;">
              <el-option
                v-for="purpose in loanPurposes"
                :key="purpose.code"
                :value="purpose.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ purpose.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ purpose.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item>
            <el-button type="primary" @click="handleFilter">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 产品表格 -->
      <div class="product-table" v-loading="loading">
        <el-table
          :data="products"
          style="width: 100%"
          border
          stripe
          highlight-current-row
        >
          <el-table-column
              prop="id"
              label="id"
              width="80"
          >
          </el-table-column>
          <el-table-column
            prop="bank_id"
            label="银行"
            width="120"
          >
            <template #default="scope">
              {{ getBankName(scope.row.bank_id) }}
            </template>
          </el-table-column>

          <el-form-item label="产品系列">
            <el-select v-model="filters.product_series" placeholder="请选择产品系列" clearable style="width: 200px;">
              <el-option
                v-for="series in productSeries"
                :key="series.code"
                :value="series.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ series.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ series.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文档类型">
            <el-select v-model="filters.doc_type" placeholder="请选择文档类型" clearable style="width: 200px;">
              <el-option
                v-for="type in docTypes"
                :key="type.code"
                :value="type.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ type.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ type.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item> 

          <el-table-column
            prop="loan_type"
            label="贷款类型"
            width="120"
          >
            <template #default="scope">
              {{ getLoanTypeName(scope.row.loan_type) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="loan_purpose"
            label="贷款用途"
            width="120"
          >
            <template #default="scope">
              {{ getLoanPurposeName(scope.row.loan_purpose) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="interest_rate_min"
            label="最低利率"
            width="100"
          >
            <template #default="scope">
              {{ scope.row.interest_rate_min }}%
            </template>
          </el-table-column>

          <el-table-column
            prop="repayment_method"
            label="还款方式"
            width="120"
          >
            <template #default="scope">
              {{ getRepaymentMethodName(scope.row.repayment_method) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="loan_amount_max"
            label="最高贷款金额"
            width="150"
          >
            <template #default="scope">
              {{ formatMoney(scope.row.loan_amount_max) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="max_lvr_percent"
            label="最大贷款成数"
            width="120"
          >
            <template #default="scope">
              {{ scope.row.max_lvr_percent }}%
            </template>
          </el-table-column>

          <el-table-column
            prop="borrower_type"
            label="借款人类型"
            width="150"
          >
            <template #default="scope">
              {{ getBorrowerTypeName(scope.row.borrower_type) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="product_series"
            label="产品系列"
            width="120"
          >
            <template #default="scope">
              {{ getProductSeriesName(scope.row.product_series) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="doc_type"
            label="文档类型"
            width="120"
          >
            <template #default="scope">
              {{ getDocTypeName(scope.row.doc_type) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="notes"
            label="备注信息"
            min-width="200"
            show-overflow-tooltip
          />

          <el-table-column
            label="操作"
            width="200"
            fixed="right"
          >
            <template #default="scope">

              <el-button
                size="small"
                type="primary"
                @click="viewPolicies(scope.row.id)"              >
                政策{{ scope.row.policy_count }} 
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <productFormDialog  ref="productFormDialog" />

  </div>
</template>

<script>
import axios from 'axios'
import { getDict } from '@/utils/dictCache'
import ProductFormDialog from "@/components/ProductFormDialog.vue";

export default {
  components: {
    ProductFormDialog, 
  },
  name: 'ProductList',
  data() {
    return {
      loading: false,
      enumLoading: true,
      products: [],
      filters: {
        bank_id: '',
        loan_type: '',
        loan_purpose: '',
        product_series: '',
        doc_type: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    banks() {
      return getDict('BANK')
    },
    loanTypes() {
      return getDict('LOAN_TYPE')
    },
    loanPurposes() {
      return getDict('LOAN_PURPOSE')
    },
    productSeries() {
      return getDict('PRODUCT_SERIES')
    },
    docTypes() {
      return getDict('DOC_TYPE')
    }
  },
  async created() {
    try {
      await this.fetchProducts()
    } catch (error) {
      this.$message.error('获取产品列表失败')
      console.error(error)
    } finally {
      this.enumLoading = false
    }
  },
  methods: {
    viewPolicies(productId) {
    this.$router.push({
      path: '/policies',
      query: { product_id: productId }
    });
  },
    formatMoney(amount) {
      if (!amount) return '暂无'
      return '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    
    async fetchProducts() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize
        }
        
        // 添加筛选条件
        if (this.filters.bank_id) params.bank_id = this.filters.bank_id
        if (this.filters.loan_type) params.loan_type = this.filters.loan_type
        if (this.filters.loan_purpose) params.loan_purpose = this.filters.loan_purpose
        if (this.filters.product_series) params.product_series = this.filters.product_series
        if (this.filters.doc_type) params.doc_type = this.filters.doc_type
        
        const response = await axios.get('https://aidata.haimoney.com.au/api/loan_products.php', { params })
        this.products = response.data.items
        this.total = response.data.total
      } catch (error) {
        this.$message.error('获取产品列表失败')
        console.error(error)
      }
      this.loading = false
    },

    getDictName(type, code) {
      if (!code) return '暂无'
      const dictList = getDict(type)
      const dict = dictList.find(item => item.code === code)
      return dict ? dict.code : code
    },

    getBankName(code) {
      return this.getDictName('BANK', code)
    },

    getLoanTypeName(code) {
      return this.getDictName('LOAN_TYPE', code)
    },

    getLoanPurposeName(code) {
      return this.getDictName('LOAN_PURPOSE', code)
    },

    getInterestTypeName(code) {
      return this.getDictName('INTEREST_TYPE', code)
    },

    getRepaymentMethodName(code) {
      return this.getDictName('REPAYMENT_METHOD', code)
    },

    getRepaymentFrequencyName(code) {
      return this.getDictName('REPAYMENT_FREQUENCY', code)
    },

    getApplicablePeopleName(code) {
      if (!code) return '暂无'
      const codes = code.split(',')
      const names = codes.map(c => this.getDictName('APPLICABLE_PEOPLE', c))
      return names.join('、')
    },

    getApplicationChannelName(code) {
      if (!code) return '暂无'
      const codes = code.split(',')
      const names = codes.map(c => this.getDictName('APPLICATION_CHANNEL', c))
      return names.join('、')
    },

    getBorrowerTypeName(code) {
      if (!code) return '暂无'
      const codes = code.split(',')
      const names = codes.map(c => this.getDictName('BORROWER_TYPE', c))
      return names.join('、')
    },

    getSupportServicesName(code) {
      if (!code) return '暂无'
      const codes = code.split(',')
      const names = codes.map(c => this.getDictName('SUPPORT_SERVICES', c))
      return names.join('、')
    },

    getProductSeriesName(code) {
      return this.getDictName('PRODUCT_SERIES', code)
    },

    getDocTypeName(code) {
      return this.getDictName('DOC_TYPE', code)
    },

    handleEdit(row) {
      this.$refs.productFormDialog.show(row)
    },

    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该产品吗？删除后将无法恢复。', '提示', {
          type: 'warning'
        })
        await axios.delete(`https://aidata.haimoney.com.au/api/loan_products.php?id=${row.id}`)
        this.$message.success('删除成功')
        this.fetchProducts()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
          console.error(error)
        }
      }
    },

    handleFilter() {
      this.currentPage = 1
      this.fetchProducts()
    },

    handleReset() {
      this.filters = {
        bank_id: '',
        loan_type: '',
        loan_purpose: '',
        product_series: '',
        doc_type: ''
      }
      this.currentPage = 1
      this.fetchProducts()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchProducts()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchProducts()
    },

    viewPolicies(productId) {
      this.$router.push({
        path: '/policies',
        query: { product_id: productId }
      })
    }
  }
}
</script>

<style scoped>
.product-list {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-area {
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.product-table {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.el-table {
  margin-top: 15px;
}

.el-table .el-button {
  padding: 4px 8px;
  margin: 0 4px;
}

.el-table .el-button + .el-button {
  margin-left: 4px;
}

.el-select {
  width: 200px;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-form-item__label {
  font-weight: 500;
}

.el-input__inner {
  height: 32px;
  line-height: 32px;
}

.el-message {
  min-width: 300px;
}

.el-message--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

.el-message--error {
  background-color: #fef0f0;
  border-color: #fde2e2;
}

.el-message__content {
  font-size: 14px;
}
</style> 